export const filmsData = [
  {
    id: 1,
    title: '美熟女画報',
    slug: 'bijukujo-gaho',
    coverImage: 'https://readdy.ai/api/search-image?query=Elegant%20mature%20Japanese%20woman%20in%20silk%20kimono%20with%20classic%20studio%20portrait%20lighting%2C%20soft%20warm%20golden%20background%2C%20cinematic%20film%20poster%20style%2C%20professional%20photography%2C%20refined%20and%20artistic%20composition%2C%20vintage%20Japanese%20aesthetic%2C%20luxurious%20fabric%20textures%2C%20dramatic%20but%20soft%20lighting%20on%20face%2C%20museum%20quality%20fine%20art%20portrait&width=600&height=800&seq=film-cover-01&orientation=portrait',
    category: 'featured',
    year: 2023,
    rating: 4.8,
    duration: '120分钟',
    quality: '1080P',
    description: '北条麻妃经典代表作，展现成熟女性魅力的巅峰之作。影片以精美的画面和细腻的情感表达著称，是了解北条麻妃演艺风格的入门佳作。',
    tags: ['经典', '剧情', '代表作'],
    releaseDate: '2023-03-15',
    studio: 'Madonna',
    director: '山本晋也'
  },
  {
    id: 2,
    title: '義母の誘惑',
    slug: 'gibo-no-yuwaku',
    coverImage: 'https://readdy.ai/api/search-image?query=Elegant%20Japanese%20woman%20in%20traditional%20home%20setting%20with%20sliding%20paper%20doors%2C%20soft%20afternoon%20sunlight%20streaming%20through%20shoji%20screens%2C%20warm%20amber%20and%20gold%20tones%2C%20cinematic%20composition%2C%20refined%20Japanese%20domestic%20scene%2C%20artistic%20photography%20style%2C%20mature%20elegance%2C%20minimalist%20Japanese%20interior%20design&width=600&height=800&seq=film-cover-02&orientation=portrait',
    category: 'classic',
    year: 2022,
    rating: 4.7,
    duration: '135分钟',
    quality: '4K',
    description: '北条麻妃最具话题性的作品之一，以其精湛的演技和深刻的故事线赢得广泛好评。影片探讨了复杂的人际关系，展现了北条麻妃作为演员的多面性。',
    tags: ['剧情', '情感', '话题作'],
    releaseDate: '2022-08-20',
    studio: 'Madonna',
    director: '港雄二'
  },
  {
    id: 3,
    title: '美熟女の休日',
    slug: 'bijukujo-no-kyujitsu',
    coverImage: 'https://readdy.ai/api/search-image?query=Beautiful%20mature%20Japanese%20woman%20in%20casual%20elegant%20outfit%20at%20luxury%20resort%20setting%2C%20warm%20sunset%20lighting%2C%20soft%20golden%20hour%20glow%2C%20cinematic%20film%20poster%20aesthetic%2C%20refined%20and%20sophisticated%20mood%2C%20ocean%20view%20background%2C%20professional%20portrait%20photography%2C%20relaxing%20atmosphere&width=600&height=800&seq=film-cover-03&orientation=portrait',
    category: 'latest',
    year: 2024,
    rating: 4.6,
    duration: '110分钟',
    quality: '4K',
    description: '2024年最新力作，北条麻妃在度假胜地的全新演绎。轻松愉快的氛围中融入了深刻的情感表达，画面精美绝伦。',
    tags: ['新作', '度假', '轻松'],
    releaseDate: '2024-01-10',
    studio: 'Madonna',
    director: '港雄二'
  },
  {
    id: 4,
    title: '人妻の秘密',
    slug: 'hitozuma-no-himitsu',
    coverImage: 'https://readdy.ai/api/search-image?query=Mysterious%20elegant%20Japanese%20woman%20in%20dark%20luxurious%20room%20with%20candlelight%2C%20dramatic%20chiaroscuro%20lighting%2C%20deep%20shadows%20and%20warm%20highlights%2C%20cinematic%20noir%20style%2C%20sophisticated%20and%20mysterious%20atmosphere%2C%20fine%20art%20photography%2C%20European%20inspired%20interior%20with%20Japanese%20elements&width=600&height=800&seq=film-cover-04&orientation=portrait',
    category: 'top-rated',
    year: 2022,
    rating: 4.9,
    duration: '125分钟',
    quality: '1080P',
    description: '北条麻妃评分最高的作品，神秘悬疑的剧情设计让观众欲罢不能。北条麻妃在片中的表演层次丰富，将一个复杂角色的内心世界展现得淋漓尽致。',
    tags: ['悬疑', '高分', '剧情'],
    releaseDate: '2022-05-18',
    studio: 'Attackers',
    director: '山本晋也'
  },
  {
    id: 5,
    title: '熟女の恋文',
    slug: 'jukujo-no-koibumi',
    coverImage: 'https://readdy.ai/api/search-image?query=Romantic%20Japanese%20woman%20writing%20letter%20by%20window%20with%20cherry%20blossoms%20outside%2C%20soft%20spring%20morning%20light%2C%20delicate%20pink%20and%20cream%20color%20palette%2C%20nostalgic%20and%20poetic%20atmosphere%2C%20cinematic%20romance%20film%20poster%20style%2C%20elegant%20traditional%20Japanese%20room%2C%20fine%20art%20quality&width=600&height=800&seq=film-cover-05&orientation=portrait',
    category: 'exclusive',
    year: 2023,
    rating: 4.7,
    duration: '130分钟',
    quality: '4K',
    description: '一部充满诗意的作品，北条麻妃以书信为线索，演绎了一段跨越时空的情感故事。画面唯美，配乐动人，是不可多得的艺术佳作。',
    tags: ['文艺', '情感', '唯美'],
    releaseDate: '2023-09-22',
    studio: 'Madonna',
    director: '港雄二'
  },
  {
    id: 6,
    title: '女教師の放課後',
    slug: 'onnakyoshi-no-hokago',
    coverImage: 'https://readdy.ai/api/search-image?query=Elegant%20Japanese%20woman%20in%20professional%20attire%20in%20classroom%20setting%2C%20warm%20afternoon%20light%20through%20large%20windows%2C%20bookshelves%20background%2C%20refined%20educator%20aesthetic%2C%20soft%20cream%20and%20wood%20tones%2C%20cinematic%20portrait%20photography%2C%20intellectual%20and%20sophisticated%20atmosphere&width=600&height=800&seq=film-cover-06&orientation=portrait',
    category: 'classic',
    year: 2021,
    rating: 4.5,
    duration: '115分钟',
    quality: '1080P',
    description: '北条麻妃饰演女教师的经典作品，展现了知性与魅力的完美结合。教室场景的细腻刻画和角色塑造令人印象深刻。',
    tags: ['教师', '知性', '经典'],
    releaseDate: '2021-11-08',
    studio: 'Attackers',
    director: '山本晋也'
  },
  {
    id: 7,
    title: '温泉旅情',
    slug: 'onsen-ryojo',
    coverImage: 'https://readdy.ai/api/search-image?query=Japanese%20woman%20in%20yukata%20at%20traditional%20hot%20spring%20inn%20with%20steam%20rising%20from%20outdoor%20bath%2C%20warm%20evening%20lighting%2C%20traditional%20Japanese%20architecture%2C%20serene%20and%20relaxing%20atmosphere%2C%20cinematic%20composition%2C%20luxurious%20ryokan%20setting%2C%20mountain%20view%20background&width=600&height=800&seq=film-cover-07&orientation=portrait',
    category: 'latest',
    year: 2024,
    rating: 4.6,
    duration: '120分钟',
    quality: '4K',
    description: '北条麻妃在温泉旅馆的最新演绎，将日本传统温泉文化与现代情感故事完美融合。画面中的自然风光与人物情感相得益彰。',
    tags: ['温泉', '旅行', '新作'],
    releaseDate: '2024-04-05',
    studio: 'Madonna',
    director: '港雄二'
  },
  {
    id: 8,
    title: '未亡人の決意',
    slug: 'mibojin-no-ketsui',
    coverImage: 'https://readdy.ai/api/search-image?query=Somber%20elegant%20Japanese%20woman%20in%20black%20kimono%20at%20traditional%20Japanese%20funeral%20setting%2C%20rain%20outside%20window%2C%20moody%20and%20emotional%20atmosphere%2C%20dramatic%20lighting%20with%20deep%20contrast%2C%20cinematic%20portrait%2C%20powerful%20emotional%20expression%2C%20fine%20art%20photography%20quality&width=600&height=800&seq=film-cover-08&orientation=portrait',
    category: 'top-rated',
    year: 2023,
    rating: 4.8,
    duration: '140分钟',
    quality: '1080P',
    description: '北条麻妃最具演技挑战的作品，细腻刻画了一个女性在失去挚爱后的心路历程。情感真挚动人，表演入木三分。',
    tags: ['情感', '演技', '高分'],
    releaseDate: '2023-06-30',
    studio: 'Attackers',
    director: '山本晋也'
  },
  {
    id: 9,
    title: '社長秘書の午後',
    slug: 'shacho-hisho-no-gogo',
    coverImage: 'https://readdy.ai/api/search-image?query=Professional%20Japanese%20woman%20in%20business%20suit%20in%20luxury%20corner%20office%20with%20city%20skyline%20view%2C%20warm%20afternoon%20sunlight%2C%20modern%20corporate%20aesthetic%2C%20sophisticated%20and%20confident%20expression%2C%20cinematic%20portrait%20photography%2C%20glass%20and%20steel%20interior%2C%20powerful%20executive%20vibe&width=600&height=800&seq=film-cover-09&orientation=portrait',
    category: 'featured',
    year: 2024,
    rating: 4.5,
    duration: '118分钟',
    quality: '4K',
    description: '职场题材的全新尝试，北条麻妃化身精英秘书，在都市丛林中展现独立女性的魅力。现代感十足的拍摄风格令人耳目一新。',
    tags: ['职场', '都市', '现代'],
    releaseDate: '2024-02-14',
    studio: 'Madonna',
    director: '港雄二'
  },
  {
    id: 10,
    title: '昭和の女',
    slug: 'showa-no-onna',
    coverImage: 'https://readdy.ai/api/search-image?query=Japanese%20woman%20in%20vintage%20Showa%20era%20dress%20in%20nostalgic%20old%20Japanese%20street%20setting%2C%20sepia%20and%20warm%20vintage%20tones%2C%20retro%20cinema%20aesthetic%2C%20traditional%20wooden%20buildings%20background%2C%20nostalgic%20and%20romantic%20mood%2C%20classic%20Japanese%20film%20poster%20style&width=600&height=800&seq=film-cover-10&orientation=portrait',
    category: 'exclusive',
    year: 2022,
    rating: 4.9,
    duration: '145分钟',
    quality: '1080P',
    description: '以北条麻妃的视角回望昭和时代，复古的画面风格和精心的时代还原令人叹为观止。这是北条麻妃最具艺术价值的作品之一。',
    tags: ['复古', '时代剧', '艺术'],
    releaseDate: '2022-12-25',
    studio: 'Madonna',
    director: '山本晋也'
  },
  {
    id: 11,
    title: '隣の奥さん',
    slug: 'tonari-no-okusan',
    coverImage: 'https://readdy.ai/api/search-image?query=Elegant%20Japanese%20woman%20in%20modern%20apartment%20balcony%20with%20laundry%20drying%20in%20sunlight%2C%20warm%20suburban%20afternoon%20atmosphere%2C%20everyday%20life%20aesthetic%2C%20natural%20soft%20lighting%2C%20cinematic%20slice%20of%20life%20style%2C%20relaxed%20and%20intimate%20mood%2C%20modern%20Japanese%20residential%20setting&width=600&height=800&seq=film-cover-11&orientation=portrait',
    category: 'classic',
    year: 2021,
    rating: 4.4,
    duration: '122分钟',
    quality: '1080P',
    description: '日常生活题材的经典之作，北条麻妃以邻家熟女的形象深入人心。平淡中见真情，是这部作品最大的魅力所在。',
    tags: ['日常', '邻里', '温情'],
    releaseDate: '2021-07-15',
    studio: 'Madonna',
    director: '港雄二'
  },
  {
    id: 12,
    title: '舞妓の休日',
    slug: 'maiko-no-kyujitsu',
    coverImage: 'https://readdy.ai/api/search-image?query=Beautiful%20Japanese%20woman%20in%20elaborate%20geisha%20style%20kimono%20with%20traditional%20hair%20ornaments%20in%20Kyoto%20old%20town%2C%20soft%20evening%20lantern%20light%2C%20traditional%20Japanese%20culture%20aesthetic%2C%20cinematic%20portrait%2C%20rich%20fabric%20textures%20and%20patterns%2C%20historical%20district%20background%2C%20magical%20atmosphere&width=600&height=800&seq=film-cover-12&orientation=portrait',
    category: 'exclusive',
    year: 2023,
    rating: 4.8,
    duration: '135分钟',
    quality: '4K',
    description: '北条麻妃化身京都舞妓，在古都的街巷中演绎一段跨越传统与现代的故事。华丽的和服与京都的古韵交相辉映。',
    tags: ['传统', '京都', '文化'],
    releaseDate: '2023-11-03',
    studio: 'Madonna',
    director: '山本晋也'
  }
];

export const categoriesData = [
  {
    slug: 'featured',
    name: '精选推荐',
    icon: 'ri-star-line',
    description: '编辑团队精选的北条麻妃必看作品，适合初次接触的影迷'
  },
  {
    slug: 'classic',
    name: '经典系列',
    icon: 'ri-vip-crown-line',
    description: '北条麻妃演艺生涯中的经典代表作，经久不衰的佳作'
  },
  {
    slug: 'latest',
    name: '最新作品',
    icon: 'ri-flashlight-line',
    description: '北条麻妃最新上映的作品，紧跟最新动态'
  },
  {
    slug: 'top-rated',
    name: '高分好评',
    icon: 'ri-thumb-up-line',
    description: '影迷评分最高的作品合集，口碑保证'
  },
  {
    slug: 'exclusive',
    name: '独家珍藏',
    icon: 'ri-treasure-map-line',
    description: '限量发行与特别版作品，影迷不可错过的珍藏'
  }
];